var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95735 1.0853H2.98934C1.89066 1.0853 1 1.97596 1 3.07464V15.0107C1 16.1094 1.89066 17 2.98934 17H14.9254C16.0241 17 16.9147 16.1094 16.9147 15.0107V9.04262M15.3374 5.47598L16.4174 4.39601C17.1942 3.61912 17.1942 2.35954 16.4174 1.58267C15.6404 0.805777 14.3809 0.805777 13.6039 1.58268L12.524 2.66263M15.3374 5.47598L9.33324 11.4802C9.05553 11.7579 8.70182 11.9472 8.31679 12.0243L5.39069 12.6094L5.9759 9.68339C6.05293 9.29826 6.24222 8.94455 6.51993 8.66684L12.524 2.66263M15.3374 5.47598L12.524 2.66263",
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.9cc0d02c7e1ecb38d70dfdb5503d97e1.svg";
export { ForwardRef as ReactComponent };